import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c6839c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "billNotify flex-ter-bwn"
}

import { reactive, onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useRtfix } from '@/store'
import { userBillNotify, readBillNotify } from '@/apis/usercenter'
import AppLink from '@/components/common/AppLink.vue'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()

onMounted(() => {
  getData()
})

const notifyData = ref()
// 获取列表
const getData = () => {
  userBillNotify().then((res: any) => {
    if (res.code === '0' && res.data) {
      notifyData.value = res.data
    }
  })
}

const getNotifyText = () => {
  const { billAmt = 0, billKrAmt = 0 } = notifyData.value ?? {}
  if (billAmt > 0 && billKrAmt > 0) {
    const text = ` ${t('您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币、YY韩元），请前往“资金管理”进行查看').replace('XX', billAmt).replace('YY', billKrAmt)} >`
    const link = useRtfix('StoreFund', { query: { fundFlowType: 6, bizContentCustomerList: `${t('库存保管费')},${t('包裹滞留费')}`, currencyCode: 'CNY' } })
    return { text, link }
  }
  if (billAmt > 0) {
    const text = ` ${t('您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币），请前往“资金管理”进行查看').replace('XX', billAmt)} >`
    const link = useRtfix('StoreFund', { query: { fundFlowType: 6, bizContentCustomerList: `${t('库存保管费')},${t('包裹滞留费')}`, currencyCode: 'CNY' } })
    return { text, link }
  }
  if (billKrAmt > 0) {
    const text = ` ${t('您本月的库存保管费和包裹滞留费账单已生成（合计XX韩元），请前往“资金管理”进行查看').replace('XX', billKrAmt)} >`
    const link = useRtfix('StoreFund', { query: { fundFlowType: 6, bizContentCustomerList: `${t('库存保管费')},${t('包裹滞留费')}`, currencyCode: 'KRW' } })
    return { text, link }
  }
  return { text: '', link: '' }
}
const readBill = () => {
  readBillNotify({
    code: notifyData.value.code
  })
}

const close = () => {
  readBillNotify({
    code: notifyData.value.code
  }).then(res => {
    notifyData.value = null
  })
}


return (_ctx: any,_cache: any) => {
  return (notifyData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AppLink, {
          to: getNotifyText().link,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _unref(taTrack)({
                event: _unref(TaEvent).BTN_CLICK,
                value: {
                position: 'bill_notice'
                }
            })
        ))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(getNotifyText().text), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("img", {
          src: "https://static-jp.theckb.com/static-asset/client/activity/close.png",
          alt: "",
          class: "close",
          onClick: close
        })
      ]))
    : _createCommentVNode("", true)
}
}

})